import preprocessResponse from 'ha/utils/preprocessResponse';
import createGraphqlError from 'ha/utils/graphql/createGraphqlError';
import isGraphqlError from 'ha/utils/graphql/isGraphqlError';
import reportError from 'ha/helpers/bugsnag/reportError';

class GraphqlNetworkError extends Error {
  name = 'GraphqlNetworkError';
}

const makeGraphQLClient = fetchClient => (query, variables) =>
  fetchClient
    .fetch('/api/v1/graphql', {
      method: 'post',
      body: JSON.stringify({ query, variables }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(preprocessResponse)
    .then(response => {
      if (!response) {
        return Promise.reject(
          createGraphqlError({
            errors: [
              {
                message: 'Unexpected error from GraphQL Server!',
                locations: [],
                query,
                variables,
              },
            ],
          }),
        );
      }

      if (response.errors && response.errors.length > 0) {
        return Promise.reject(createGraphqlError(response.errors));
      }

      return response;
    })
    .catch(err => {
      if (!isGraphqlError(err)) {
        reportError('Graphql client error', { metaData: { err } });
      }

      if (err && err.code) {
        const errorMsg = ['code', 'status', 'body'].reduce((acc, key) => {
          if (err[key]) {
            return `${acc} ${key}: ${err[key]};`;
          }

          return acc;
        }, 'Graphql network issue ::');

        return Promise.reject(new GraphqlNetworkError(errorMsg));
      }

      return Promise.reject(err);
    });

export default makeGraphQLClient;
